// import React from "react";

// const Footer = () => (
//   <footer className="text-center mt-16">
//     <p className="text-gray-400">©  2024 LockedIn by <span className="text-rose-500 animate-bounce">Aryan Sharma</span></p>
//   </footer>
// );

// export default Footer;


import React from "react";

const Footer = () => (
  <footer className="text-center mt-16 px-4">
    <p className="text-gray-400">
      © 2024 LockedIn by <span className="text-rose-500 animate-bounce">
      <a className="underline" href="https://github.com/ARYAN-CODES-STAR/" target="_blank" rel="noreferrer">Aryan Sharma</a>
      </span>
    </p>
  </footer>
);

export default Footer;
